module.exports = __webpack_public_path__ + "img/background_person.9a909cc5.png";